module.exports = __webpack_public_path__ + "assets/img/xf_info.bf955b89.png";